import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { useLenis } from "@/hooks/useLenis";
import Landing from "@/pages/Landing";
import Vehicles from "@/pages/Vehicles";
import RequestForm from "@/pages/RequestForm";
import BuildRequest from "@/pages/BuildRequest";
import Performance from "@/pages/Performance";
import Faq from "@/pages/Faq";
import Resources from "@/pages/Resources";
import PaymentSuccess from "@/pages/PaymentSuccess";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  useLenis();
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <div className="grain" />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/vehicles" element={<Vehicles />} />
            <Route path="/tuning" element={<RequestForm type="tuning" />} />
            <Route path="/fabrication" element={<RequestForm type="fabrication" />} />
            <Route path="/build" element={<BuildRequest />} />
            <Route path="/performance" element={<Performance />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
          <Toaster
            theme="dark"
            position="bottom-right"
            toastOptions={{
              style: {
                background: "#111111",
                border: "1px solid #222222",
                borderRadius: 0,
                color: "#FAFAFA",
                fontFamily: "IBM Plex Mono, monospace",
              },
            }}
          />
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
